import type { BatchBadgeProps } from './batch-card/types';
import { Show } from '@/components/conditional-component';
import { MapPin } from 'lucide-react';
import * as React from 'react';
export function BatchBadge({
  batchNumber,
  location,
  mode,
  isRegular,
  isOwn
}: BatchBadgeProps) {
  return <div className="flex w-full items-center gap-2 whitespace-nowrap text-center text-sm leading-none tracking-normal text-gray-600" data-sentry-component="BatchBadge" data-sentry-source-file="batch-badge.tsx">
      {mode === 'Online' ? <>
              <div className="my-auto self-stretch rounded bg-x-accent-beta-pale px-1 py-[1px] text-xs font-semibold text-x-accent-beta-base">{mode}</div>
              <div className="my-auto self-stretch text-xs text-gray-400">•</div>
            </> : <>
              <div className="my-auto flex gap-1 self-stretch text-xs">
                {mode === 'Offline' && <MapPin size={15} className="fill-gray-400 text-gray-200" />}
                {mode === 'Offline' ? location : mode}
              </div>
              <div className="my-auto self-stretch text-xs text-gray-400">•</div>
            </>}
      <div className="my-auto self-stretch text-xs">
        B
        {batchNumber}
      </div>
      <Show when={isRegular && !isOwn} data-sentry-element="Show" data-sentry-source-file="batch-badge.tsx">
        <div className="my-auto self-stretch text-xs text-gray-400">•</div>
        <div className="my-auto self-stretch text-xs">Regular</div>
      </Show>
    </div>;
}
;